

















































































import Component from 'vue-class-component';
import {IDictionary} from '@/entities/dictionary.interface';
import {IFormControl} from '@/entities/form.interface';
import {EditPage} from '@/components/base/edit/edit-page';
import adminsApi from '@/api/admins.api';
import {IListItem} from '../../../entities/list-item.interface';
import * as types from '@/store/types';
import { IAdminAccountModel, IAdminEditModel } from '@/entities';

const passwordDefaultValidator = 'confirmed:passwordConfirm'; // TODO move to entities valid-rules.ts

@Component({
})
export default class AdminsEdit extends EditPage {

    public parentPath: string = '/app/admins';

    //  public companies: IListItem[] = [];
    public formState: IDictionary<IFormControl> = {
        email: {
            key: 'email',
            label: 'Email',
            value: '',
            validators: 'required|email'
        },
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required|max:10'
        },
        password: {
            key: 'password',
            label: 'Password',
            value: '',
            validators: passwordDefaultValidator
        },
        passwordConfirm: {
            key: 'passwordConfirm',
            label: 'Confirm Password',
            value: '',
            validators: ''
        },
        earningVisible: {
            key: 'earningVisible',
            label: 'Earning Visible',
            value: false,
            validators: ''
        },
         approveAgents: {
            key: 'approveAgents',
            label: 'Approve Agents',
            value: false,
            validators: ''
        },
        showSuspend: {
            key: 'showSuspend',
            label: 'Show Suspended',
            value: false,
            validators: ''
        },
        showCommonLogs: {
            key: 'showCommonLogs',
            label: 'Show Common Logs',
            value: false,
            validators: ''
        }
    };

    protected adminPermissions: boolean;
    protected companyId: number | null;

    public async created() {
        await super.created();

        // companiesApi.list().then((items: ICompany[]) => {
        //     this.companies = items.map((x) => {
        //         return {value: x.id, heading: x.officeName};
        //     });
        // });

        if (this.isNew) {
            this.formState = {
                ...this.formState,
                password: {
                    ...this.formState.password,
                    validators: passwordDefaultValidator + '|required'
                },
                passwordConfirm: {
                    ...this.formState.passwordConfirm,
                    validators: 'required'
                }
            };
        }
        this.formState.password.value = '';
        this.formState.passwordConfirm.value = '';
    }

    // TODO own resourse service will be nice for api calls
    public detail(id: number): Promise<IAdminAccountModel> {
        return adminsApi.get(id);
    }

    public create(body: IAdminEditModel): Promise<number> {
        return adminsApi.create(body);
    }

    public update(body: any): Promise<number> {
        return adminsApi.update(this.id, body);
    }

}
